<template>
  <div>
    <div v-for="(month, index) in months" :key="index" class="pb-8 px-3 -mx-3 overflow-hidden">
      <calendar-header :month="month" />
      <calendar-grid
        :month="month"
        :from="value"
        :to="null"
        @click="handleDateClicked" />
    </div>
  </div>
</template>

<script>
import CalendarHeader from '../DateRangePicker/CalendarHeader'
import CalendarGrid from '../DateRangePicker/CalendarGrid'

export default {
  props: {
    value: {
      required: true
    }
  },
  components: {
    CalendarHeader,
    CalendarGrid
  },
  computed: {
    months () {
      let cursor = moment().startOf('month')
      const numberOfMonths = 25
      const months = []

      while (months.length < numberOfMonths) {
        months.push(cursor)

        cursor = moment().add(months.length, 'months')
      }

      return months
    }
  },
  methods: {
    handleDateClicked (date) {
      this.$emit('input', date)
    }
  }
}
</script>